import { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

// Gallery-styled QR — cyan dots on near-black, white finder squares.
export default function SaleQRCode({ value, size = 208 }) {
  const holder = useRef(null);
  const inst = useRef(null);

  useEffect(() => {
    inst.current = new QRCodeStyling({
      width: size,
      height: size,
      type: 'svg',
      data: value || 'https://therelativegallery.com',
      margin: 6,
      qrOptions: { errorCorrectionLevel: 'M' },
      backgroundOptions: { color: '#050505' },
      dotsOptions: { color: '#90E0EF', type: 'square' },
      cornersSquareOptions: { color: '#ffffff', type: 'square' },
      cornersDotOptions: { color: '#90E0EF', type: 'square' },
    });
    if (holder.current) {
      holder.current.innerHTML = '';
      inst.current.append(holder.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  useEffect(() => {
    if (inst.current && value) inst.current.update({ data: value });
  }, [value]);

  return <div ref={holder} data-testid="sale-qr-code" className="inline-block" />;
}
